import React, { FunctionComponent } from 'react';
import { googleClickNavEvent } from '../../../../utils/analytics';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { SecondaryLinkModel } from '../navigationItem/models/navigationItem.model';

const SecondaryLink: FunctionComponent<{ model: SecondaryLinkModel; onClick: () => void; menuTitle?: string }> = ({
  model,
  onClick,
  menuTitle,
}) => {
  return (
    <RoutableSitecoreLink
      field={model.link}
      className="navigation-link navigation-link--secondary"
      onClick={(): void => {
        onClick();
        googleClickNavEvent('Global Nav', menuTitle, model?.link?.value?.title || model?.link?.value?.text);
      }}
    />
  );
};

export default SecondaryLink;
